import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const feedbackType = [
  {id:1, name:"Satisfied", value:"satisfied"},
  {id:2, name:"Neutral", value:"neutral"},
  {id:3, name:"Unsatisfied", value:"unsatisfied"},
]

const FeedbackReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let { loading, dataPaginating, setDataPaginating, generalSettings } =
    useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);
  const { branchForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);

  const componentRef = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);

  const [siteName, setSiteName] = useState("");
  const [branch, setBranch] = useState(null);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    if (generalSettings) {
      setSiteName(getSystemSettings(generalSettings, "siteName"));
    }
  }, [generalSettings]);

  const handleBranch = (branches) => {
    setBranch(branches);
  };

  const handleFeedback = (feedback) => {
    setFeedback(feedback);
  };

  //get BranchWise reports filter
  const getFeedbackReport = () => {
    setReportData(null);
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !branch?.id
    ) {
      toast.error(`${_t(t("Please select branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    if (startDate !== null && endDate !== null) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");

      const url = BASE_URL + "/settings/feedback-report";
      let formData = new FormData();
      formData.append("from_date", fromDate);
      formData.append("to_date", toDate);
      formData.append("feedback_type", feedback ? feedback?.value : "");
      formData.append("branch_id", branch?.id ? branch?.id : "");

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setReportData(res.data);
          setGeneratedReport(true);
          setDataPaginating(false);
          componentRef.current.handleDownload();
          setBranch(null);
          setFeedback(null);
        })
        .catch((error) => {
          setDataPaginating(false);
        });
    } else {
      toast.error(`${_t(t("Please select from date, to date"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  let g_total = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Feedback Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Feedback Report"
        sheet="sheet 1"
        buttonText="Feedback Detail"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <style type="text/css" media="print">
            {
              "\
              @page { size: landscape; }\
            "
            }
          </style>
          <div className="fk-print">
            <div className="row">
              <div className="col-12">
                {reportData !== null &&
                  reportData !== undefined &&
                  generatedReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="22" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Feedback Report
                                      </h3>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">{startDate}</Moment>
                                        &nbsp;TO&nbsp;
                                        <Moment format="LL">{endDate}</Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                >
                                  {_t(t("S/L"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Token"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Order Date"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Feedback Date"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Branch"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Order Type"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Party Name"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Waiter Name"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Customer"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Feedback"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Feedback Type"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Reason"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Remarks"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Ambiance Rating"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Ambiance Feedback"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Food Rating"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Food Feedback"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Serving Rating"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Serving Feedback"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Over All Rating"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("General Feedback"))}
                                </th>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Net Amount"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              {reportData &&
                                reportData.map((item, i) => {
                                  g_total += Number(item.total_payable)
                                  return (
                                    <tr key={i}>
                                      <td scope="row">{i + 1}</td>
                                      <td>{item?.token}</td>
                                      <td scope="row">
                                        <Moment format="LL">
                                          {item.OrderDate}
                                        </Moment>
                                      </td>
                                      <td scope="row">
                                        <Moment format="LL">
                                          {item.feedback_date}
                                        </Moment>
                                      </td>
                                      <td scope="row">{item.branch_name}</td>
                                      <td>{item.OrderTypeName}</td>
                                      <td scope="row">
                                        {item.PartyName}
                                      </td>
                                      <td scope="row">{item.waiter_name}</td>
                                      <td scope="row">{item.Customer || "-"}</td>
                                      <td scope="row">{item.feedback || "-"}</td>
                                      <td scope="row">{item.feedback_type || "-"}</td>
                                      <td scope="row">{item.Reason}</td>
                                      <td scope="row">{item.Remarks || "-"}</td>
                                      <td scope="row">{item.ambienceRating || "-"}</td>
                                      <td scope="row">{item.ambienceFeedBack || "-"}</td>
                                      <td scope="row">{item.foodRating || "-"}</td>
                                      <td scope="row">{item.foodFeedback || "-"}</td>
                                      <td scope="row">{item.servingRating || "-"}</td>
                                      <td scope="row">{item.servingFeedBack || "-"}</td>
                                      <td scope="row">{item.overAllrating || "-"}</td>
                                      <td scope="row">{item.generalFeedback || "-"}</td>
                                      <td scope="row">{item.total_payable}</td>
                                    </tr>
                                  );
                                })}
                              <tr>
                                <td colSpan={20} scope="row">
                                </td>
                                <th scope="row">
                                  Total
                                </th>
                                <td scope="row">
                                  <strong>{g_total}</strong>
                                </td>
                              </tr>  
                            </tbody>
                            <tfoot style={{ border: "0px" }}>
                              <tr style={{ border: "0px" }}>
                                <td
                                  colspan="10"
                                  className="text-center"
                                  style={{ border: "0px" }}
                                >
                                  <h5 className="mt-3">Powered by indolj.pk</h5>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>

                    {/* spin loading ends */}

                    {/* Loading effect {loading === true ? (
                      tableLoading()
                    ) : ( */}

                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-12 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Feedback Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-2 t-mb-15 mb-md-0">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            classNamePrefix="select"
                            value={branch || ""}
                            className="table-text"
                            styles={customStyle}
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select branch")) + ".."}
                            isClearable
                          />
                        </div>

                        <div className="col-3 t-mb-15 mb-md-0">
                          <Select
                            options={feedbackType ? feedbackType : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            classNamePrefix="select"
                            value={feedback || ""}
                            className="table-text"
                            styles={customStyle}
                            onChange={handleFeedback}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select feedback type")) + ".."}
                            isClearable
                          />
                        </div>
                        <div className="col-1"></div>
                        <div className="col-2">
                          <button
                            className="float-right btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                            onClick={(e) => getFeedbackReport(e)}
                          >
                            Feedback Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default FeedbackReport;
